<template>
<div>


<Toolbar class="contenttopbar">
<template #start>
<h3 class="text-primary mb-2 mt-2 font-medium">{{$store.state.languages.lang_phrases.tedarikci_gorusmeleri}}</h3>
</template>
<template #end>
<Dropdown :filter="true"  v-model="filterbyproject" :options="filterbyprojects" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm" placeholder="Projeye göre filtrele" @change="filterByProject">

<template #value="slotProps">
  <template v-if="slotProps.value">
    {{optionName}}
  </template>
  <template v-else>
    <div style="height:18px"></div>
  </template>
</template>

<template #option="slotProps">
{{ getTheTranslation(slotProps.option,"translation") }}
</template>

</Dropdown>


<Button type="button" class="ml-2 p-button-primary p-button-outlined p-button-sm" :label="$store.state.languages.lang_phrases.yeni_ekle" icon="pi pi-plus" @click="addNew" />



</template>
</Toolbar>


<template v-if="adding_new">

<div class="grid mt-4" >
<div class="col-12">
<Dropdown :filter="true"  v-model="selected_project" :options="projects" optionLabel="name" optionValue="id" class=" p-inputtext-sm">

<template #value="slotProps">
    {{submitOptionName}}
</template>

<template #option="slotProps">
{{ getTheTranslation(slotProps.option,"translation") }}
</template>

</Dropdown>

<Dropdown :filter="true"  v-model="selected_contact" :options="supplier_users" optionLabel="name" optionValue="user_id" class="ml-2 p-inputtext-sm" placeholder="Görüşülen Kullanıcı">

<template #value="slotProps">
    {{userOptionName}}
</template>

<template #option="slotProps">
{{ getTheTranslation(slotProps.option,"translation") }}
</template>

</Dropdown>
</div>


<div class="col-12">
<Textarea   v-model="conversation" class="w-full p-inputtext-sm"   rows="8" />
</div>

<div class="col-12 flex align-items-center justify-content-end">
<Button type="button" class="p-button-danger p-button-outlined p-button-sm" :label="$store.state.languages.lang_phrases.iptal"  :loading="$store.state.ui.submitting" @click="cancelNew" />
<Button type="button" class="p-button-primary p-button-outlined p-button-sm ml-2" :label="$store.state.languages.lang_phrases.kaydet"  :loading="$store.state.ui.submitting" @click="submit" />
</div>
<div class="col-12">
	<hr>
</div>

</div>
</template>



<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>



<div class="content_card_content" v-if="!loading">


<template v-if="items.length==0">
<div class="flex align-items-center justify-content-center mb-8 mt-8">
<h3 class="text-primary font-medium">{{$store.state.languages.lang_phrases.henuz_hic_kayit_olusturulmamis}}</h3>
</div>
</template>


<template v-else>

<div class="grid grid-nogutter mt-4" v-for="item in filtered_items">
<div class="col-9">


<p>
<!--project name-->
<template v-if="item.project">
<Tag 
class="mr-2  custom-chip font-medium"  
 icon="pi pi-calendar" 
:value="getTheTranslation(item.project,'translation')" 
style="background-color:#352f8d"
/>

</template>
<template v-else>
<Tag 
class="mr-4  custom-chip font-medium"   
:value="$store.state.languages.lang_phrases.genel" 
style="background-color:#4dc247"
/>
</template>
<!--project name-->

<!--contact name-->
<template v-if="item.connectedwith">
<Tag 
class="mr-2  custom-chip font-medium"   
 icon="pi pi-user"
:value="item.connectedwith.name" 
style="background-color:#6366f1"
/>

</template>

<!--contact name-->

</p>

</div>

<div class="col-3 flex align-items-end justify-content-center pr-1 flex-column">
<p class="text-primary text-xs font-semibold mb-0">{{ $filters.momentFormat( item.created_at," Do-MM-YYYY hh:mm")}}</p>
<small class="text-purple-500"><span v-if="$store.state.auth.user.preflang_id==15">{{$store.state.languages.lang_phrases.tarafindan}}</span> <b>{{item.submitted_by.name}}</b> <span v-if="$store.state.auth.user.preflang_id==3">{{$store.state.languages.lang_phrases.tarafindan}}</span></small>
</div>

<div class="col-12 mt-2">
<p v-html="item.conversation"></p>
</div>
<div class="col-12">
	<hr>
</div>




</div>	
	
</template>


</div>



</div>	
</template>

<script>
export default {

  name: 'SupplierConversations',

  data () {
    return {
    	items:[],
    	filtered_items:[],
    	projects:[],
    	supplier_users:[],
    	loading:true,
    	adding_new:false,
    	conversation:null,
    	selected_project:0,
    	selected_contact:0,
    	filterbyprojects:[],
    	filterbyproject:"all",
    }
  },
  computed:{
    optionName()
    {
      if(this.filterbyproject)
      {
        let project = this.filterbyprojects.find(item=>item.id == this.filterbyproject)
        if(project)
        {
          return this.getTheTranslation(project,"translation")
        }
      }
      return ""      
    },
    submitOptionName()
    {
      if(this.selected_project)
      {
        let project = this.projects.find(item=>item.id == this.selected_project)
        if(project)
        {
          return this.getTheTranslation(project,"translation")
        }
      }
      else if(this.selected_project===0)
      {
        let project = this.projects.find(item=>item.id == this.selected_project)
        if(project)
        {
          return this.getTheTranslation(project,"translation")
        }
      }
      return ""
    },
    userOptionName()
    {
      if(this.selected_contact || this.selected_contact===0)
      {
        let project = this.supplier_users.find(item=>item.user_id == this.selected_contact)
        if(project)
        {
          return this.getTheTranslation(project,"translation")
        }
      }
      return ""
    },
  },
  mounted()
  {
  	this.getData()
  },
  methods:{
  	filterByProject()
  	{
  		let items
  		console.log(this.filterbyproject)
  		if(this.filterbyproject=="all")
  		{
  			items = this.items
  		}
  		else
  		{
  			items = this.items.filter((item)=>{return item.project_id == this.filterbyproject})
  		}
  		this.filtered_items = items

  	},
  	addNew()
  	{
  		this.adding_new = true
  	},
  	cancelNew()
  	{
  		this.adding_new = false
  	},
  	submit()
  	{
  		if(!this.conversation || this.conversation == "")
  		{
  			return false
  		}
  		console.log(this.conversation)
  		
  		
  		let formdata = new FormData()
  		formdata.append("conversation",this.conversation.replace(/\n\r?/g, '<br />'))
  		formdata.append("project_id",this.selected_project)
  		formdata.append("contacted_with",this.selected_contact)
  		console.log(this.selected_contact)
  		//return  false
  		this.generalSubmission(formdata,"supplier/conversation/"+this.$route.params.id,this.afterSubmit)  		

  	},
  	afterSubmit(response)
  	{
  		console.log(response.data)
  		this.items = response.data
  		this.filtered_items = response.data
  		this.conversation = null
  		this.adding_new = false
  		this.selected_project = 0
  		this.selected_contact = 0

  	},
  	async getData()
    {
      this.loading = await true
      let items = await this.generalApiGetWithoutLoader("supplier/conversations/"+this.$route.params.id) 
      this.supplier_users = await this.generalApiGetWithoutLoader("supplier/users/"+this.$route.params.id) 
      console.log(this.supplier_users)
       this.supplier_users.forEach(item => item.name = item.name+" - "+item.email)

      await this.supplier_users.push(
        {
          user_id:0,
          name:"Kayıtlı Değil",
          translations:[{language_id:3,translation:"Kayıtlı Değil"},{language_id:15,translation:"Not on Records"}]
        })
      let projects = await this.generalApiGetWithoutLoader("supplier/audits_for_conversations/"+this.$route.params.id) 
      
      let real_projects = []
      for(let item of projects)
      {
      	//item.name = await item.project.name+" - "+item.projectperiod.name
        let ind = real_projects.findIndex((element)=>{return element.id == item.project_id})
        if(ind==-1)
        {
          real_projects.push(item.project)
        }
      }

      await real_projects.push(
        {
          id:0,
          name:"Genel",
          translations:[{language_id:3,translation:"Genel"},{language_id:15,translation:"General"}]
        })

      this.filterbyprojects = await this.sanitizeArray(real_projects)
      this.filterbyprojects.push(
        {id:"all",
        name:"Hepsi",
        translations:[{language_id:3,translation:"Hepsi"},{language_id:15,translation:"All"}]
      })
      console.log(this.filterbyprojects)
      this.projects = await real_projects
      this.items = await items
      this.filtered_items = await items
      this.loading = await false
    },  
  }
}
</script>

<style lang="css" scoped>
</style>